import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import Spinner from "components/svg/Spinner";

export default function DecisionProfile({
  decision,
  isSelected,
  onClick,
  onUpdate,
  onDelete,
}: any) {

  return (
    <tr>
      <td className={`border-t border-slate-100 py-3 px-4 font-light text-sm w-full`}>{decision.name}</td>
      <td className={`border-t border-slate-100 py-3 px-4 font-light text-sm`}>
        <Menu as="div" className="ml-3">
          <div className="show-spinner">
            <Menu.Button
              className="font-medium text-xs text-blue-700"
              id="user-menu-button"
              title={`Actions for ${decision.id}`}
              aria-expanded="false"
              aria-haspopup="true"
            >
              <span className="sr-only">Open actions menu</span>
              Actions
            </Menu.Button>
            <Spinner className="block mx-auto h-4 w-4 text-gray-300" />
          </div>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items
              className="origin-top-right absolute text-left mt-1 rounded-sm shadow-lg py-0 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="user-menu-button"
            >
              <Menu.Item>
                <div
                  className="block px-4 py-2 text-xs cursor-pointer hover:bg-gray-50"
                  role="menuitem"
                  title={`Update ${decision.id}`}
                  onClick={onUpdate}
                >
                  Update
                </div>
              </Menu.Item>
              <Menu.Item>
                <div
                  className="block px-4 py-2 text-xs cursor-pointer hover:bg-gray-50"
                  role="menuitem"
                  title={`Remove ${decision.id}`}
                  onClick={() => onDelete(decision.id)}
                >
                  Remove
                </div>
              </Menu.Item>
            </Menu.Items>
          </Transition>
        </Menu>
      </td>
    </tr>
  );
}
